import { useState, useEffect } from "react";
import { Country } from "../../api";
import CountrySelectBase, { CountrySelectBaseProps } from "./CountrySelectBase";

export interface CountrySelectAsyncProps extends Omit<CountrySelectBaseProps, 'countries'> {
  countries: Promise<Country[]>
};

const CountrySelectAsync = (props: CountrySelectAsyncProps) => {
  const [countries, setCountries] = useState<Country[]>([]);
  const [error, setError] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    props.countries
      .then((countries) => {
        setLoading(false);
        setError(false);
        setCountries(countries);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
        setError(true);
      });
  }, []);

  return <CountrySelectBase
    {...props}
    countries={countries}
    errorMessage={error ? props.errorMessage : undefined}
    loadingMessage={loading ? props.loadingMessage : undefined}
  />
}

export default CountrySelectAsync;
